import { enUS, es } from "date-fns/locale";
import i18next, { type i18n } from "i18next";

export const getDateFnsLocale = (i18nLocale: i18n["language"]) => {
	switch (i18nLocale) {
		case "en":
			return enUS;
		case "es":
			return es;
		default:
			return enUS;
	}
};

// Transform date-fns (enUS) language code to Intl language code (en-US)
const FOUR_CHAR_LANG_CODE_LENGTH = 4;
export const parseLangCode = (lang: string) => {
	if (lang.length === FOUR_CHAR_LANG_CODE_LENGTH) {
		return `${lang.slice(0, 2)}-${lang.slice(2)}`;
	}

	return lang;
};

export function formatDate(date: Date | string | number | undefined, opts: Intl.DateTimeFormatOptions = {}) {
	if (!date) {
		return "";
	}

	try {
		return new Intl.DateTimeFormat(parseLangCode(i18next.language), opts).format(new Date(date));
	} catch (error) {
		// biome-ignore lint/suspicious/noConsole: Debug purposes
		console.error(error);

		return "ERROR FORMATTING DATE";
	}
}
